/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import { FormControl, FormGroup } from "react-bootstrap-3";

function InputGroup({ value, hasErrors, onChange, field, disabled, readOnly, type, min = 0 }) {
  const { fieldName, placeholder, maxLength } = field;
  return (
    <div className={`InputGroup ${field.className}`}>
      <FormGroup>
        <FormControl
          value={value}
          type={type || "text"}
          placeholder={placeholder}
          disabled={disabled}
          className={`form-control ${hasErrors && "parsley-error"}`}
          onChange={event => onChange({ event, field: fieldName })}
          readOnly={readOnly}
          maxLength={maxLength}
          min={min}
        />
      </FormGroup>
    </div>
  );
}

InputGroup.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
};

export default InputGroup;
